export function isHomeStyleRegistrationHash(hash: string): boolean {
  return hash.replace(/^#\/?/, "").split("?")[0] === "home-style/projects/new";
}
